module.exports = __webpack_public_path__ + "static/og-image-1fa78ee03cf3d13bf15f4a02fa1dc53b.png";